import ActivityZakat from './ActivityZakat';

export default ActivityZakat;
